import React from 'react';

import {
  CreateCsrotpSessionMutation,
  Otp_Channel,
  Otp_Platform,
  useCreateCsrotpSessionMutation,
} from '@occc/graphql';
import { snackbar } from '@occc-app/design-system';

import { SendOTPCodeModal } from './send-otp-code.modal';

const onError = () => {
  snackbar.error('Something went wrong. Please try again.');
};

type SendOTPCodeModalContainerProps = {
  memberPhone: string;
  isOpen: boolean;
  onHide: () => void;
  onCompleted: (value: CreateCsrotpSessionMutation) => void;
};

export const SendOTPCodeModalContainer = ({
  memberPhone,
  isOpen,
  onHide,
  onCompleted,
}: SendOTPCodeModalContainerProps) => {
  const [createCSROTPSessionMutation, { loading }] = useCreateCsrotpSessionMutation({
    variables: {
      input: {
        phoneNumber: memberPhone,
        otpChannel: Otp_Channel.Sms,
        otpPlatform: Otp_Platform.Web,
      },
    },
    onCompleted: onCompleted,
    onError,
  });

  return (
    <SendOTPCodeModal
      isOpen={isOpen}
      onHide={onHide}
      onConfirmButtonClick={createCSROTPSessionMutation}
      isLoading={loading}
    />
  );
};
